import Panel from './Panel';
import SplitterComp from './Splitter';
const Splitter = SplitterComp;
Splitter.Panel = Panel;
export default Splitter;
